<script setup lang="ts">
import type { CmsSectionDefault } from "@shopware-pwa/composables-next";
import { getCmsLayoutConfiguration } from "@shopware-pwa/helpers-next";

const props = defineProps<{
  content: CmsSectionDefault;
}>();

const { cssClasses, layoutStyles } = getCmsLayoutConfiguration(props.content);
</script>

<template>
  <div>
  <CmsGenericBlock
    class="cms-section-default"
    v-for="cmsBlock in content.blocks"
    :key="cmsBlock.id"
    :class="cssClasses"
    :styles="layoutStyles"
    :content="cmsBlock"
  />
  </div>
</template>
